module.exports = __webpack_public_path__ + "static/media/heartbeat.6b74ba7c.svg";